import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";

const formatElapsed = (startTime: number, now: number): string => {
  const totalSeconds = Math.max(0, Math.floor((now - startTime) / 1_000));
  const seconds = String(totalSeconds % 60).padStart(2, "0");
  const totalMinutes = Math.floor(totalSeconds / 60);

  if (totalMinutes < 60) {
    return `${String(totalMinutes).padStart(2, "0")}:${seconds}`;
  }

  const hours = String(Math.floor(totalMinutes / 60)).padStart(2, "0");
  const minutes = String(totalMinutes % 60).padStart(2, "0");
  return `${hours}:${minutes}:${seconds}`;
};

export const OperationalTimer = ({ startTime }: { startTime?: Date | string | null }) => {
  const { ref, inView } = useInView({ rootMargin: "200px 0px", threshold: 0 });
  const [now, setNow] = useState(Date.now);
  const start = startTime instanceof Date
    ? startTime.getTime()
    : startTime ? Date.parse(startTime) : Number.NaN;
  const isValid = Number.isFinite(start);

  useEffect(() => {
    if (!inView || !isValid) return;

    let timeout = 0;
    const update = () => {
      const current = Date.now();
      setNow(current);
      const elapsedRemainder = ((current - start) % 1_000 + 1_000) % 1_000;
      timeout = window.setTimeout(update, Math.max(50, 1_000 - elapsedRemainder));
    };

    update();
    return () => window.clearTimeout(timeout);
  }, [inView, isValid, start]);

  if (!isValid) return null;

  return <span ref={ref}>{formatElapsed(start, now)}</span>;
};
